import { ResponsiveBar } from "@nivo/bar";
import { Empty } from "antd";
import { Loader } from "../loader";

interface ICreateDashboard {
  datas: any;
  loader: boolean;
}
export const BarChart1: React.FC<ICreateDashboard> = ({ datas, loader }) => {
  const data = [
    {
      count: 0,
      month: "",
    },
  ];
  const itemList = datas;
  return (
    <>
      {loader ? (
        <div className="flex w-full justify-center items-center h-full">
          <Loader />
        </div>
      ) : itemList?.length > 0 ? (
        <ResponsiveBar
          data={itemList ? itemList : data}
          keys={["count"]}
          indexBy="month"
          margin={{ top: 50, right: 40, bottom: 50, left: 60 }}
          padding={0.3}
          valueScale={{ type: "linear" }}
          indexScale={{ type: "band", round: true }}
          colors={"#B574E0"}
          defs={[
            {
              id: "dots",
              type: "patternDots",
              background: "inherit",
              color: "#38bcb2",
              size: 4,
              padding: 1,
              stagger: true,
            },
            {
              id: "lines",
              type: "patternLines",
              background: "inherit",
              color: "#eed312",
              rotation: -45,
              lineWidth: 6,
              spacing: 10,
            },
          ]}
          fill={[
            {
              match: {
                id: "fries",
              },
              id: "dots",
            },
            {
              match: {
                id: "sandwich",
              },
              id: "lines",
            },
          ]}
          borderColor={{
            from: "color",
            modifiers: [["darker", 1.6]],
          }}
          axisTop={null}
          enableGridY={false}
          axisRight={null}
          axisBottom={{
            tickSize: 5,
            tickPadding: 5,
            tickRotation: 0,
            legend: "Month",
            legendPosition: "middle",
            legendOffset: 32,
          }}
          axisLeft={{
            tickSize: 5,
            tickPadding: 5,
            tickRotation: 0,
            legend: "Count",
            legendPosition: "middle",
            legendOffset: -40,
          }}
          labelSkipWidth={12}
          labelSkipHeight={12}
          labelTextColor={{
            from: "color",
            modifiers: [["darker", 1.6]],
          }}
          role="application"
          ariaLabel="Nivo bar chart demo"
          barAriaLabel={(e) =>
            e.id + ": " + e.formattedValue + " in country: " + e.indexValue
          }
        />
      ) : (
        <Empty className="w-full h-full flex justify-center items-center flex-col" />
      )}
    </>
  );
};
